export const setSpotlightsStyles = (style: React.CSSProperties) => {
  const spotlight = document.querySelector('.react-joyride__spotlight') as HTMLDivElement
  if (!spotlight) return

  for (const [key, value] of Object.entries(style)) {
    spotlight.style[key as never] = value
  }
}

export const setElementStyles = (className: string, style: React.CSSProperties) => {
  const element = document.querySelector(className) as HTMLDivElement
  if (!element) return

  for (const [key, value] of Object.entries(style)) {
    element.style[key as never] = value
  }
}
